import { memo, type ReactNode } from 'react';
import { ENTITY_UNIFIED_LIFECYCLE_PANEL_CLASS } from './entityUnifiedModalStyles.js';

export interface EntityUnifiedLifecyclePanelProps {
  readonly children: ReactNode;
  readonly testId?: string;
  readonly className?: string;
}

/** Shared lifecycle tab panel chrome — reading shell + form-field measure via CSS. */
export const EntityUnifiedLifecyclePanel = memo<EntityUnifiedLifecyclePanelProps>(({
  children,
  testId,
  className,
}) => (
  <div
    className={[ENTITY_UNIFIED_LIFECYCLE_PANEL_CLASS, className].filter(Boolean).join(' ')}
    data-testid={testId}
  >
    {children}
  </div>
));

EntityUnifiedLifecyclePanel.displayName = 'EntityUnifiedLifecyclePanel';
